import { render, staticRenderFns } from "./iconfont.vue?vue&type=template&id=0180a6ca&scoped=true"
import script from "./iconfont.vue?vue&type=script&lang=js"
export * from "./iconfont.vue?vue&type=script&lang=js"
import style0 from "./iconfont.vue?vue&type=style&index=0&id=0180a6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180a6ca",
  null
  
)

export default component.exports